export default __webpack_public_path__ + "static/media/navbar-img-2.36d2fa26.jpg";